import React from 'react';
import {EdgeProps} from 'reactflow';

import BaseEdgeRenderer from 'ui-library/reactflow/edges/BaseEdgeRenderer';

export default function TaskSchemaControlFlowEdge(props: EdgeProps): JSX.Element {
  return <BaseEdgeRenderer {...props} />;
}
